/** 需要 AI 生成的内容类型 */
export enum SpecificationContentType {
    /** 技术类型 */
    Category = 'category',
    /** 技术三要素获取 */
    TechWrapper = 'tech_wrapper',
    /** 权力要求-技术特树 */
    FeatureTree = 'feature_tree',
    /** 说明书正文-生成标题 */
    Title = 'title',
    /** 说明书正文-技术领域 */
    TechField = 'tech_field',
    /** 说明书正文-背景技术 */
    Background = 'background',
    /** 说明书正文-发明内容 */
    Summary = 'summary',
    /** 说明书正文-具体实施方式 */
    Embodiment = 'embodiment',
    /** 说明书正文-新实施例 */
    EmbodimentOutline = 'embodiment_outline',
    /** 说明书正文-具体实施例子模块 */
    EmbodimentItem = 'embodiment_content',
    /** 说明书正文-具体实施方式结论 */
    EmbodimentConclusion = 'embodiment_conclusion',
    /** 说明书正文-摘要 */
    Abstract = 'abstract',
    /** 说明书正文-图 */
    Figures = 'figures',
    /** 说明书正文-图描述 */
    FigureDescription = 'figures_description',
    /** 说明书正文-摘要附图 */
    AbstractFigure = 'abstract_figure',
}

/** 生成操作类型 */
export enum SpecificationOperateType {
    /** 生成 */
    Generate = 'generate',
    /** 重写 */
    Regenerate = 'regenerate',
}

/** 说明书正文内容类型 */
export type SpecificationParagraphContentType =
    | SpecificationContentType.Title
    | SpecificationContentType.TechField
    | SpecificationContentType.Background
    | SpecificationContentType.Summary
    | SpecificationContentType.Embodiment
    | SpecificationContentType.EmbodimentOutline
    | SpecificationContentType.EmbodimentItem
    | SpecificationContentType.Abstract
    | SpecificationContentType.Figures
    | SpecificationContentType.FigureDescription
    | SpecificationContentType.AbstractFigure;


/**
 * 说明书正文优化类型
 */
export enum SpecificationParagraphOptimizeType {
    /** 改写 */
    Polish = 'polish',
    /** 简写 */
    Simplify = 'simplify',
    /** 扩写 */
    Expand = 'expand',
    /** 续写 */
    ContinueWriting = 'continue',
}

/**
 * 说明书正文段落可 AI 编辑类型
 */
export enum SpecificationParagraphAiEditType {
    /** 简写 */
    Simplify = 'specification_simplify',
    /** 扩写 */
    Expand = 'specification_expand',
    /** 改写 */
    Polish = 'specification_polish',
    /** 续写 */
    ContinueWriting = 'specification_continue_writing',
    /** 添加实施例 */
    AddEmbodiment = 'specification_add_embodiment',
    /** 追加实施例 */
    AppendEmbodiment = 'specification_append_embodiment',
    /** 优化实施例 */
    ImproveEmbodiment = 'specification_improve_embodiment',
}

export enum SpecificationStep {
    /** 任务还没有创建 */
    Empty = '',
    /** 创建 AI 生成说明书任务 */
    Create = 'SPECIFICATION_INPUT',
    /** 确认交底书 */
    ConfirmDisclosure = 'SPECIFICATION_DISCLOSURE_RESULT',
    /** 确认权利要求书 */
    ConfirmClaims = 'CLAIM_PARSER',
    /** 生成说明书内容 */
    GenContent = 'SPECIFICATION_RESULT',
}

export enum SpecificationJurisdiction {
    US = 'USPTO',
    CN = 'CNIPA',
    EU = 'EPO',
}

export * from './upload-status';
